var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharacter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.602 64.4354C22.509 60.5283 27.808 58.3333 33.3333 58.3333H66.6667C72.1921 58.3333 77.4912 60.5283 81.3979 64.4354C85.305 68.3421 87.5 73.6412 87.5 79.1667V87.5C87.5 89.8012 85.6346 91.6667 83.3333 91.6667C81.0321 91.6667 79.1667 89.8012 79.1667 87.5V79.1667C79.1667 75.8517 77.8496 72.6721 75.5054 70.3279C73.1612 67.9837 69.9817 66.6667 66.6667 66.6667H33.3333C30.0181 66.6667 26.8387 67.9837 24.4945 70.3279C22.1503 72.6721 20.8333 75.8517 20.8333 79.1667V87.5C20.8333 89.8012 18.9678 91.6667 16.6667 91.6667C14.3655 91.6667 12.5 89.8012 12.5 87.5V79.1667C12.5 73.6412 14.6949 68.3421 18.602 64.4354Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 16.6667C43.0962 16.6667 37.5 22.2631 37.5 29.1667C37.5 36.0702 43.0962 41.6667 50 41.6667C56.9037 41.6667 62.5 36.0702 62.5 29.1667C62.5 22.2631 56.9037 16.6667 50 16.6667ZM29.1666 29.1667C29.1666 17.6608 38.494 8.33334 50 8.33334C61.5058 8.33334 70.8333 17.6608 70.8333 29.1667C70.8333 40.6726 61.5058 50 50 50C38.494 50 29.1666 40.6726 29.1666 29.1667Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacter);
export default __webpack_public_path__ + "static/media/character.c9dd5627fe1469adde031d8294347a0c.svg";
export { ForwardRef as ReactComponent };